export default __webpack_public_path__ + "static/media/standard_03.fe2c2deb.png";